import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'core/ui/Button';
import Overlay from 'core/components/Overlay';
import Close from 'core/icons/Close';
import { getColor } from 'core/utils';
import { resetBtn } from 'styled-manila';

const Wrapper = styled.div`
	margin: 50px auto;
	width: 300px;
	padding: 30px;
	background-color: ${getColor('white')};
	border-radius: 4px;
	position: relative;

	@media (min-width: 768px) {
		width: 500px;
		padding: 44px 88px;
	}
`;

const Body = styled.div`
	color: ${getColor("gray")};
	margin-bottom: 2rem;
`;

const DismissBtn = styled.button`
	${resetBtn};
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	right: 0;
	color: ${getColor('dustyGray')};
	padding: 17px;
`;

class ReportConfirm extends Component {
	state = {
		confirmed: false,
	}

	handleConfirm = () => {
		this.setState({ confirmed: true });
		this.props.onConfirm();
	}

	render() {
		const { onClose } = this.props;
		const { confirmed } = this.state;
		return (
			<Overlay noCloseBtn dismiss={onClose}>
				<Wrapper>
					<DismissBtn onClick={onClose}>
						<Close width="10" height="10" fill="currentColor" />
					</DismissBtn>
					<Body>
						<h3>
							{confirmed ?
								'Thank you for your feedback' :
								'Report Abuse'
							}
						</h3>
						{confirmed ?
							'We appreciate your vote.' :
							'If you find this content inappropriate and think it should be removed from Cratejoy, let us know by clicking the button below.'
						}
					</Body>
					{!confirmed &&
						<Button onClick={this.handleConfirm} size="sm" themeType="danger">Report</Button>
					}
				</Wrapper>
			</Overlay>
		);
	}
}

ReportConfirm.propTypes = {
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
};

export default ReportConfirm;
